import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkActivate({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ projectMember }) => <>{projectMember?.member?.name}</>;

  return (
    <BulkActionModal
      title="Activate Team Members"
      confirmText="Activate"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .members()
          .bulkSetActiveStatus(ids, true)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will activate ${
        ids.length === 1 ? 'the selected team member' : `the ${ids.length} selected team members`
      } on this project.`}
    </BulkActionModal>
  );
}
